export default {
  costConfirmationList: {
    column: {
      index: '序号',
      tenantCode: '租户编码',
      companyCode: '公司编码',
      departmentCode: '部门编码',
      companyName: '公司名',
      departmentName: '部门名',
      gmtCreate: '记录创建时间',
      gmtModified: '记录更新时间',
      lastModifiedBy: '记录最后更新人',
      isDeleted: '是否删除(1删除,0未删除)',
      sortNo: '序号',
      version: '版本',
      businessCompanyCode: '业务公司',
      businessCompanyName: '业务公司名称',
      businessDepartmentCode: '业务部门',
      businessDepartmentName: '部门名',
      projectCode: '项目代码',
      projectName: '项目名称',
      periodName: '成本确认账期',
      createPersonNo: '操作人',
      createPersonName: '操作人名称',
      partnerCode: '供应商',
      partnerName: '供应商名称',
      createDate: '创建日期',
      createDateStart: '创建日期起',
      createDateEnd: '创建日期止',
      settlementCount: '结算数量',
      settlementCountUnit: '结算数量(千克)',
      settlementCountUnitEN: '结算数量(KG)',
      settlementPriceWithoutTax: '不含税结算单价',
      settlementPriceWithoutTaxUnit: '不含税结算单价(元/千克)',
      settlementAmountWithoutTax: '不含税结算金额',
      settlementAmountWithoutTaxUnit: '不含税结算金额(元)',
      settlementAmountWithoutTaxUnitEN: '不含税结算金额(￥)',
      settlementPriceWithTax: '含税结算单价',
      settlementPriceWithTaxUnit: '含税结算单价(元/千克)',
      settlementAmountWithTax: '含税结算金额',
      settlementAmountWithTaxUnit: '含税结算金额(元)',
      settlementAmountWithTaxUnitEN: '含税结算金额(￥)',
      confirmNo: '成本确认单号',
      confirmYear: '成本确认年度',
      confirmMonth: '成本确认月份',
      goodsType: '商品类别',
      goodsTypeName: '原料类别',
      productParentCode: '商品父编码(6位)',
      productParentName: '商品父名称',
      productDetailCode: '商品详细编码(12位)',
      productDetailName: '商品详细名称',
      contractDate: '合同日期',
      contractDateStart: '合同日期起',
      contractDateEnd: '合同日期止',
      transAndStoreContractDate: '合同日期',
      taxRate: '税率',
      productCode: '原料编码',
      productName: '原料名称',
      productSpec: '规格型号',
      productType: '主料/辅料',
      productCategory: '原料大类',
      tranAndStoreCost: '运输仓储费',
      month: '月',
      subTotal: '小计',
      count: '计数',
      inboundNo: '原料入库编号',
    },
    placeholder: {
      tenantCode: '请输入租户编码',
      companyCode: '请输入公司编码',
      departmentCode: '请输入部门编码',
      companyName: '请输入公司名',
      departmentName: '请输入部门名',
      gmtCreate: '请选择记录创建时间',
      gmtModified: '请选择记录更新时间',
      lastModifiedBy: '请输入记录最后更新人',
      isDeleted: '请输入是否删除(1删除,0未删除)',
      sortNo: '请输入序号',
      version: '请输入版本',
      businessCompanyCode: '请输入业务公司编码',
      businessCompanyName: '请输入业务公司名称',
      businessDepartmentCode: '请输入部门编码',
      businessDepartmentName: '请输入部门名',
      projectCode: '请输入项目代码',
      projectName: '请输入项目名称',
      productCode: '商品编码',
      productName: '商品名称',
      createPersonNo: '请输入操作人',
      createPersonName: '请输入操作人名称',
      // partnerCode:'请输入供应商',
      // partnerName:'请输入供应商名称',
      createDate: '请选择创建日期',
      confirmNo: '请输入成本确认单号',
      confirmYear: '请输入成本确认年度',
      confirmMonth: '请输入成本确认月份',
      goodsType: '请选择商品类别',
      productParentCode: '请输入商品父编码(6位)',
      productParentName: '请输入商品父名称',
      productDetailCode: '请输入商品详细编码(12位)',
      productDetailName: '请输入商品详细名称',
      partnerCode: '请输入合作伙伴编码',
      partnerName: '请输入合作伙伴名称',
      contractDate: '请选择合同日期',
      settlementCount: '请输入结算数量',
      settlementPriceWithoutTax: '请输入不含税结算单价',
      settlementAmountWithoutTax: '请输入不含税结算金额',
      settlementPriceWithTax: '请输入含税结算单价',
      settlementAmountWithTax: '请输入含税结算金额',
      taxRate: '请输入税率',
      autoRowTotal: '查询结果各行之和',
    },
    search: {
      gt: '大于',
      lt: '小于',
      notEqual: '不等于',
      equal: '等于',
      productCode: '商品编码',
      productName: '商品名称',
      taxRate: '税率(%)',
    },
    router: {
      edit: '修改',
      del: '删除',
      add: '新增成本确认',
      export: '导出',
      importData: '导入',
    },
    message: {
      noData: '您还未选择任何数据',
      pleaseSelectOne: '请选择一条数据操作',
      topFormCheckResult: '请您将数据填写完整',
      deleteSuccess: '删除成功',
      baseDataIncomplete: '请将基本数据填写完整',
      salesDataIncomplete: '请将销售数据填写完整',
      purchasingDataIncomplete: '请将采购数据填写完整',
      is_expand_apply: '数据已存在，是否扩展申请',
      return_list_page: '返回合作伙伴主数据页面',
      data_repeat: '已存在该数据',
      cancelled: '已取消',
      canNotChange: '该数据状态不可编辑',
      enable_to_forbid: '启用只针对已禁用的状态',
      forbid_to_enable: '禁用只针对已生效的状态',
      delete_to_enable: '删除只针对非生效的状态',
      merge_need_enable: '合并功能针对已生效的数据',
      saveSuccess: '保存成功',
      productNameRepeat: '校准名称行项目不能重复',
      noExport: '没有数据可供导出',
      noPeriodName: '请选择账期',
    },
    title: {
      add: '新增成本确认单',
      basicInfo: '基本信息',
      productDetailInfo: '商品详细信息',
      msgTip: '是否在当前的成本确认月中新增一行数据？',
      transAndStoreCost: '运输仓储费',
    },
    form: {
      importPeriodNameSelect: '请选择导入账期',
    },
    label: {
      periodName: '请选择账期',
    },
  },
};
